import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

//
//

export type AppTypographyProps = TypographyProps & {
  lines?: number;
};

export const AppTypography: React.FC<AppTypographyProps> = ({
  children,
  variant = 'body1',
  lines,
  ...props
}) => {
  const multilineEllipsis = lines
    ? {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: lines,
        WebkitBoxOrient: 'vertical',
      }
    : {};

  //

  return (
    <Typography sx={{ ...multilineEllipsis }} {...props} variant={variant}>
      {children}
    </Typography>
  );
};
